import { useTeamStore } from '@/hooks/useTeamStore';
import { TeamActionTypes } from '@/store/team';

type BalancePayload =
  | {
      tournamentPrice: number;
      balance: number;
    }
  | {
      balance: number;
      tournamentPrice?: undefined;
    }
  | null;

export function useBalance() {
  const { dispatch } = useTeamStore();

  const setTeamBalanceByResult = (result: BalancePayload) => {
    if (result) {
      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          ...(result.tournamentPrice && {
            tournamentPrice: result.tournamentPrice,
          }),
          balance: result.balance,
        },
      });
    }
  };

  const setTeamBalance = (balance: number) => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        balance,
      },
    });
  };

  // const getBalanceByTeam = () => {
  //   return balance;
  // }

  return { setTeamBalanceByResult, setTeamBalance };
}
